import {
    GET_ALL_REQUEST_TYPE_LIST,
    GET_ASSIGNED_TO_LIST,
    GET_BUYER_NAME_LIST,
    GET_COST_CENTER_LIST,
    GET_REGION_LIST,
    GET_REQUESTED_BY_LIST,
    GET_STATUS_LIST,
    GET_UPDATED_BY_LIST,
    SET_ALL_REQUEST_TYPE_LIST,
    SET_ASSIGNED_TO_LIST,
    SET_BUYER_NAME_LIST,
    SET_COST_CENTER_LIST,
    SET_REGION_LIST,
    SET_REQUESTED_BY_LIST,
    SET_STATUS_LIST,
    SET_UPDATED_BY_LIST,
    IS_DROP_DOWNS_LOADING,
    GET_FLEET_PROCESSORS,
    SET_FLEET_PROCESSORS
} from "./OrderGridDropdownsType"

const getAllRequestTypeList = () => ({
    type: GET_ALL_REQUEST_TYPE_LIST
});

const setAllRequestTypeList = (dropdownList: any) => ({
    type: SET_ALL_REQUEST_TYPE_LIST,
    dropdownList
});

const getStatusList = () => ({
    type: GET_STATUS_LIST
});

const setStatusList = (dropdownList: any) => ({
    type: SET_STATUS_LIST,
    dropdownList
});

const getRegionList = () => ({
    type: GET_REGION_LIST
});

const setRegionList = (dropdownList: any) => ({
    type: SET_REGION_LIST,
    dropdownList
});

const getCostCenterList = () => ({
    type: GET_COST_CENTER_LIST
});

const setCostCenterList = (dropdownList: any) => ({
    type: SET_COST_CENTER_LIST,
    dropdownList
});

const getRequestedByList = () => ({
    type: GET_REQUESTED_BY_LIST
});

const setRequestedByList = (dropdownList: any) => ({
    type: SET_REQUESTED_BY_LIST,
    dropdownList
});

const getAssignedToList = () => ({
    type: GET_ASSIGNED_TO_LIST
});

const setAssignedToList = (dropdownList: any) => ({
    type: SET_ASSIGNED_TO_LIST,
    dropdownList
});

const getUpdatedByList = () => ({
    type: GET_UPDATED_BY_LIST
});

const setUpdatedByList = (dropdownList: any) => ({
    type: SET_UPDATED_BY_LIST,
    dropdownList
});

const setIsDropDownsLoading = (flag: boolean) => ({
    type: IS_DROP_DOWNS_LOADING,
    flag
});
const getBuyerNameList = () => ({
    type: GET_BUYER_NAME_LIST
})

const setBuyerNameList = (buyerNameList: any) => ({
    type: SET_BUYER_NAME_LIST,
    buyerNameList
})

const getFleetProcessorList = () => ({
    type: GET_FLEET_PROCESSORS
});

const setFleetProcessorList = (dropdownList: any) => ({
    type: SET_FLEET_PROCESSORS,
    dropdownList
});

export {
    getAllRequestTypeList,
    setAllRequestTypeList,
    getStatusList,
    setStatusList,
    getRegionList,
    setRegionList,
    getCostCenterList,
    setCostCenterList,
    getRequestedByList,
    setRequestedByList,
    getAssignedToList,
    setAssignedToList,
    getUpdatedByList,
    setUpdatedByList,
    setIsDropDownsLoading,
    getBuyerNameList,
    setBuyerNameList,
    getFleetProcessorList,
    setFleetProcessorList
}